(function () {
    window.onload = function () {
        const scrollbarWidth = (window.innerWidth - document.documentElement.clientWidth) + "px";
        document.documentElement.style.setProperty('--scrollbar-width', scrollbarWidth);
    };
})();